import styled from 'styled-components';
import { DropdownMenuList } from '../SimpleDropdownMenu/styles';
import { Format, NewStyleColor } from '../../utils/styles-constants';

const SpinnerContainer = styled('div')`
	position: absolute;
	inset: 0;
	z-index: 13;
	background-color: ${NewStyleColor.Black};
	opacity: 0.66;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const DropdownContainer = styled('div')`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 12;
`;

const DropDownList = styled(DropdownMenuList)`
	min-width: 340px;

	@media ${Format.SmartphonePortrait} {
		min-width: 280px;
	}
`;

export {
	DropdownContainer,
	DropDownList,
	SpinnerContainer,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/styles.ts